import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IngredientTableRow } from 'business/models/Models';

type IngredientTableState = {
  selectedRows: IngredientTableRow[];
  ingTableDataIndicator: number;
};

const initialState: IngredientTableState = {
  selectedRows: [],
  ingTableDataIndicator: 0,
} as IngredientTableState;

const ingredientTableSlice = createSlice({
  name: 'ingredientTable',
  initialState,
  reducers: {
    setIngredientSelectedRows: (state, action: PayloadAction<IngredientTableRow[]>) => {
      state.selectedRows = action.payload;
    },
    setIngTableDataIndicator: (state, action: PayloadAction<number>) => {
      state.ingTableDataIndicator = action.payload;
    },
  },
});

export const { setIngredientSelectedRows, setIngTableDataIndicator } =
  ingredientTableSlice.actions;
export default ingredientTableSlice.reducer;
